$(document).ready(function () {
    $("header .site-header-menu-toggle").click(function () {
        $(this).closest("header.site-header").toggleClass("active");
    }),
        0 < $("#phone-make-select, #phone-make-select1, #phone-make-select2").length &&
            ($.each(models, function (e, t) {
                $("#phone-make-select, #phone-make-select1, #phone-make-select2").append($("<option>", { value: e }).text(t.name));
            }),
            (t = $("#phone-make-select, #phone-make-select1, #phone-make-select2").find("option:selected").val()),
            $(".phone-model-select option").remove(),
            $.each(models[t].value, function (e, t) {
                $(".phone-model-select").append($("<option>", { value: e }).text(t));
            }),
            $("#phone-make-select, #phone-make-select1, #phone-make-select2").change(function () {
                var e = $(this),
                    e = ($(".phone-model-select"), e.find(":selected").val());
                $(".phone-model-select option").remove(),
                    $.each(models[e].value, function (e, t) {
                        $(".phone-model-select").append($("<option>", { value: e }).text(t));
                    }),
                    "1" == e
                        ? ($(this).parents("div").find(".msg").removeClass("msg-is-success"), $(this).parents("div").find(".not-here").show())
                        : ($(this).parents("div").find(".msg").removeClass("msg-is-success"), $(this).parents("div").find(".not-here").hide());
            }),
            $(".phone-model-select").change(function () {
                var e = $(this).find(":selected").val();
                "1" == e
                    ? ($(this).parents("div").find(".msg").removeClass("msg-is-success"), $(this).parents("div").find(".not-here").show())
                    : ("0" == e ? $(this).parents("div").find(".msg").removeClass("msg-is-success") : $(this).parents("div").find(".msg").addClass("msg-is-success"), $(this).parents("div").find(".not-here").hide());
            }),
            $(".compat-checker .close-me").click(function () {
                $(this).parents("div").find(".msg").removeClass("msg-is-success");
            }),
            $(".compat-checker .close-me2").click(function () {
                $(this).parents("div").find(".msg.not-here").hide();
            })),
        0 < $(".related-product-slider.slider").length &&
            $(".related-product-slider.slider").slick({
                dots: !1,
                infinite: !1,
                arrows: !0,
                adaptiveHeight: !1,
                variableWidth: !1,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    { breakpoint: 992, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                    { breakpoint: 861, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                    { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                    { breakpoint: 541, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                ],
            });
    var s,
        i,
        n,
        e,
        t,
        o = document.querySelector("#qty"),
        a = document.querySelector(".product-form--atc-qty .form-field--qty-input input"),
        l = document.querySelector(".qtyminus"),
        r = document.querySelector(".qtyplus");
    function d(e) {
        var t = ["th", "st", "nd", "rd"],
            s = e % 100;
        return e + (t[(s - 20) % 10] || t[s] || t[0]);
    }
    void 0 !== o &&
        void 0 !== l &&
        void 0 !== r &&
        null !== o &&
        null !== l &&
        null !== r &&
        ((s = Number(o.getAttribute("min"))),
        (i = Number(o.getAttribute("max"))),
        (n = Number(o.getAttribute("step"))),
        l.addEventListener("click", function (e) {
            var t = Number(o.value) - n;
            t < s ? (t = s) : i < t && (t = i), (o.value = Number(t)), (a.value = Number(t)), e.preventDefault();
        }),
        r.addEventListener("click", function (e) {
            var t = Number(o.value) + n;
            i < t && (t = i), (o.value = Number(t)), (a.value = Number(t)), e.preventDefault();
        })),
        0 < $(".gallery-navigation--scroller").length &&
            $(".gallery-navigation--scroller").slick({
                arrows: !0,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                adaptiveHeight: !0,
                responsive: [
                    { breakpoint: 992, settings: { slidesToShow: 4, slidesToScroll: 1, dots: !1 } },
                    { breakpoint: 861, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                    { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                    { breakpoint: 541, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                ],
            }),
        $('.free-shipping-box-right .switch input[type="checkbox"]').change(function () {
            var e = $(this).is(":checked"),
                t = $(this);
            location.href = (e
                ? t
                      .closest(".collection--section")
                      .find(".productgrid--outer")
                      .find(".productgrid--sidebar")
                      .find(".productgrid--sidebar-group")
                      .find('ul[data-filter-group="Headset"]')
                      .find(".filter-group--wrapper")
                      .find('[data-handle="headset_type_wireless"]')
                : t
                      .closest(".collection--section")
                      .find(".productgrid--outer")
                      .find(".productgrid--sidebar")
                      .find(".productgrid--sidebar-group")
                      .find('ul[data-filter-group="Headset"]')
                      .find(".filter-group--wrapper")
                      .find('[data-handle="headset_type_corded-usb"]')
            )
                .find("a")
                .attr("href");
        }),
        0 < $(".gallery-navigation--scroller").length &&
            $(".gallery-navigation--scroller").on("mouseover", "button.product-gallery--media-thumbnail", function (e) {
                $(this).trigger("click");
            }),
        0 < $(".ship-dates").length &&
            ((e = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]),
            (t = new Date()),
            (l = String(t.getDate()).padStart(2, "0")),
            (r = String(t.getMonth()).padStart(2, "0")),
            (t = t.getFullYear()),
            (t = new Date(t, r, l, 12, 0, 0, 0, 0)),
            (r = new Date(t.getTime())).setDate(r.getDate() + 1),
            0 == r.getDay() ? r.setDate(r.getDate() + 2) : 1 == r.getDay() ? r.setDate(r.getDate() + 1) : 5 < r.getDay() && r.setDate(r.getDate() + 2),
            $(".ship-dates")
                .find("td.day1")
                .text(e[r.getMonth()] + " " + d(r.getDate())),
            (l = new Date(t.getTime())).setDate(l.getDate() + 2),
            l.getDay() <= 1 ? l.setDate(l.getDate() + 2) : 2 == l.getDay() ? l.setDate(l.getDate() + 1) : 5 < l.getDay() && l.setDate(l.getDate() + 2),
            $(".ship-dates")
                .find("td.day2")
                .text(e[r.getMonth()] + " " + d(l.getDate())),
            (t = new Date(t.getTime())).setDate(t.getDate() + 3),
            0 == t.getDay() || 1 == t.getDay() || 2 == t.getDay() ? t.setDate(t.getDate() + 2) : 3 == t.getDay() ? t.setDate(t.getDate() + 1) : 5 < t.getDay() && t.setDate(t.getDate() + 2),
            $(".ship-dates")
                .find("td.day3")
                .text(e[r.getMonth()] + " " + d(t.getDate()))),
        0 < $(".blog-container").length && (-1 < window.location.href.indexOf("tagged") || $(".block-list .block-list__item").slice(0).css("display", "none")),
        setTimeout(function () {
            0 < $("#gsc-i-id1").length && (document.getElementById("gsc-i-id1").placeholder = "Search here or use the categories below");
        }, 500);
}),
    $("#open_support .sidebar_link .sidebar_main").click(function () {
        $(".sidebar_link .sidebar-sub_link").removeClass("selected"), $(this).next().toggle("selected");
    }),
    $(document).ready(function () {
        $(".gallery-navigation--scroller").slick("unslick");
    }),
    $(":input").on("keyup change", function (e) {
        $(this).val() ? $(this).next("label").hide() : $(this).next("label").show();
    });

$(document).ready(function(){
  //   $(".learn_more_btn").click(function(){
  //     $(".prod_more_desc").toggleClass('is-open');
  //     $(".learn_more_btn").find('h4').text( $('.learn_more_btn h4').text() == 'Read More' ? "Read Less" : "Read More" );
  //   });  

  // Qty on product page
  $('.product-form__item--quantity button').click(function(e){
    e.preventDefault();
    var counter = $(this).closest('.qty').find('#product-quantity').val();
    if( $(this).hasClass('qtyminus') ){
      if(counter > 1){
        counter--;
        $(this).closest('.qty').find('#product-quantity').val(counter).trigger('change');
      }
    }else{
      counter++;
      $(this).closest('.qty').find('#product-quantity').val(counter).trigger('change');
    }
  });

  
  $(".learn_more_btn").click(function(){
    //$(".learn_more_text").slideDown();
    $(".prod-toggle-desc").addClass('is-open');
    $(this).hide();
    $(".learn_less_btn").show();
  });
  $(".learn_less_btn").click(function(){
    //$(".learn_more_text").slideUp();
    $(".prod-toggle-desc").removeClass('is-open');
    $(this).hide();
    $(".learn_more_btn").show();
  });
  // Landing-Page hover
  $('.bg-white.pt-5 .nav-tabs > li > a').hover(function() {
    $(this).tab('show');
  });

  // Landing-Page hover  
  $(document).scroll(function() {

    if ( $('.blog-seo-section').length > 0 ){

      var $this = $(this);
      var currentScroll = $(window).scrollTop(); // get current position
      var $blogTop = $('.blog-seo-section').offset().top;
      var $footTop = $('#shopify-section-static-footer').offset().top;
      var $height = $(window).height();
      var $blogRight = $('.right-col').height();

      // console.log('currentScroll', currentScroll+'--'+$blogRight);

      if (currentScroll >= $blogTop) {
        $('.left-col').addClass("fixed_me");
      } else {
        $('.left-col').removeClass("fixed_me");
      }

      if ( $('.right-col').length > 0 ){
        if ( (currentScroll+$height) > ($blogRight+250)) {
          $('.right-col').addClass("fixed_me");
          $('.seo-blog-right-grid').addClass("fixed_me");
        } else {
          $('.right-col').removeClass("fixed_me");
          $('.seo-blog-right-grid').removeClass("fixed_me");      
        }
      }

      if ((currentScroll+$height) >= $footTop) {
        $('.left-col').removeClass("fixed_me");
        $('.right-col').removeClass("fixed_me");
        $('.seo-blog-right-grid').removeClass("fixed_me");
      }
    }

  });

  if ( $('.TechnicalSpecifications').length > 0 ){
    $('.TechnicalSpecifications #tech-specs tr:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)):not(:nth-child(5))').hide();
    $('.TechnicalSpecifications .table_more').click(function(){
      $(this).hide();
      $(this).closest('.TechnicalSpecifications').find('#tech-specs tr').show();
      $('.TechnicalSpecifications #tech-specs tr:nth-child(5) td').addClass('border-btm');
    });
  }
  
  // 
  if( $('.form-options .phone-details').length > 0 ){
    var $op3 = $('.form-options [data-variant-option-index="2"]').data('variant-option-chosen-value');
    if ( $op3 == 'No' ){
      $('.phone-details').hide(); 
    }else{
      $('.phone-details').show(); 
    }
  }
  
  /* Top Icons Filter on Collection page */
  /*
  if( $('.productgrid--wrapper .compatlogos-legend').length > 0 ){
    setTimeout(function () {
      console.log('called = >');
      //phone
      if( $('.boost-pfs-filter-option.boost-pfs-filter-option-office-phone-compatible').length > 0 ){
        var $evt = $('.boost-pfs-filter-option.boost-pfs-filter-option-office-phone-compatible');
        var $chk = $evt.find('.boost-pfs-filter-option-content-inner').find('.boost-pfs-filter-option-item.boost-pfs-filter-option-label').last().hasClass('selected');      
        console.log('$chk = ',$chk);
        if($chk){
          $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.phone').addClass('active');
        }
      } else {
        $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.phone').addClass('dd_disable');
      }
      //PC
      if( $('.boost-pfs-filter-option.boost-pfs-filter-option-pc-compatible').length > 0 ){
        var $evt = $('.boost-pfs-filter-option.boost-pfs-filter-option-pc-compatible');
        var $chk = $evt.find('.boost-pfs-filter-option-content-inner').find('.boost-pfs-filter-option-item.boost-pfs-filter-option-label').last().hasClass('selected');      
        console.log('$chk = ',$chk);
        if($chk){
          $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.computer').addClass('active');
        }
      } else {
        $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.computer').addClass('dd_disable');
      }
      //bluetooth
      if( $('.boost-pfs-filter-option.boost-pfs-filter-option-bluetooth-compatible').length > 0 ){
        var $evt = $('.boost-pfs-filter-option.boost-pfs-filter-option-bluetooth-compatible');
        var $chk = $evt.find('.boost-pfs-filter-option-content-inner').find('.boost-pfs-filter-option-item.boost-pfs-filter-option-label').last().hasClass('selected');      
        console.log('$chk = ',$chk);
        if($chk){
          $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.bluetooth').addClass('active');
        }else {        
          $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.bluetooth').addClass('dd_disable');
        } 
      } else {
        $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.bluetooth').addClass('dd_disable');
      } 
      //dect
      if( $('.boost-pfs-filter-option.boost-pfs-filter-option-dect-compatible').length > 0 ){
        var $evt = $('.boost-pfs-filter-option.boost-pfs-filter-option-dect-compatible');
        var $chk = $evt.find('.boost-pfs-filter-option-content-inner').find('.boost-pfs-filter-option-item.boost-pfs-filter-option-label').last().hasClass('selected');      
        console.log('$chk = ',$chk);
        if($chk){
          $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.dect').addClass('active');
        }
      } else {
        $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.dect').addClass('dd_disable');
      }
      //unibase
      if( $('.boost-pfs-filter-option.boost-pfs-filter-option-unibase-compatible').length > 0 ){
        var $evt = $('.boost-pfs-filter-option.boost-pfs-filter-option-unibase-compatible');
        var $chk = $evt.find('.boost-pfs-filter-option-content-inner').find('.boost-pfs-filter-option-item.boost-pfs-filter-option-label').last().hasClass('selected');      
        console.log('$chk = ',$chk);
        if($chk){
          $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.unibase').addClass('active');
        }
      } else {
        $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.unibase').addClass('dd_disable');
      }
    }, 2050);
    
    setTimeout(function () {
      ( $('button[aria-label="Clear filter by Office Phone Compatible True"]').length > 0 ) ? $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.phone').addClass('active') : $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.phone').removeClass('active');
      ( $('button[aria-label="Clear filter by Pc Compatible True"]').length > 0 ) ? $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.computer').addClass('active') : $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.computer').removeClass('active');
      ( $('button[aria-label="Clear filter by Bluetooth Compatible True"]').length > 0 ) ? $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.bluetooth').addClass('active') : $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.bluetooth').removeClass('active');
      ( $('button[aria-label="Clear filter by Dect Compatible True"]').length > 0 ) ? $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.dect').addClass('active') : $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.dect').removeClass('active');
      ( $('button[aria-label="Clear filter by Unibase Compatible True"]').length > 0 ) ? $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.unibase').addClass('active') : $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.unibase').removeClass('active');
    }, 1650);
    
    function icon_filter($val){
      var $click_val = $val;
      if( $click_val != '' ){        
        if( $('.boost-pfs-filter-options-wrapper .'+$click_val).length > 0 ){         
          $('.boost-pfs-filter-options-wrapper .'+$click_val).find('.boost-pfs-filter-option-content-inner').find('.boost-pfs-filter-option-item-list li').last().trigger('click');
        }
      }
      setTimeout(function () {
        ( $('button[aria-label="Clear filter by Office Phone Compatible True"]').length > 0 ) ? $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.phone').addClass('active') : $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.phone').removeClass('active');
        ( $('button[aria-label="Clear filter by Pc Compatible True"]').length > 0 ) ? $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.computer').addClass('active') : $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.computer').removeClass('active');
        ( $('button[aria-label="Clear filter by Bluetooth Compatible True"]').length > 0 ) ? $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.bluetooth').addClass('active') : $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.bluetooth').removeClass('active');
        ( $('button[aria-label="Clear filter by Dect Compatible True"]').length > 0 ) ? $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.dect').addClass('active') : $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.dect').removeClass('active');
        ( $('button[aria-label="Clear filter by Unibase Compatible True"]').length > 0 ) ? $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.unibase').addClass('active') : $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.unibase').removeClass('active');      
        $('button[aria-label="Clear filter by Bluetooth Compatible True"]').click(function(){
          $('.site-main').find('.productgrid--outer').find('.productgrid--wrapper').find('.compatlogos-legend').find('.legend-item.bluetooth').removeClass('active');
        });      
      }, 1250);      
    }
        
    $('.legend-item').click(function(){
      var $this = $(this);
      var $phone = 'boost-pfs-filter-option-office-phone-compatible';
      var $computer = 'boost-pfs-filter-option-pc-compatible';
      var $bluetooth = 'boost-pfs-filter-option-bluetooth-compatible';
      var $dect = 'boost-pfs-filter-option-dect-compatible';
      var $unibase = 'boost-pfs-filter-option-unibase-compatible';
      if($this.hasClass('phone')){
        icon_filter($phone);  
      }      
      if($this.hasClass('computer')){
        icon_filter($computer); 
      }
      if($this.hasClass('bluetooth')){
        icon_filter($bluetooth);  
      }
      if($this.hasClass('dect')){
        icon_filter($dect); 
      }
      if($this.hasClass('unibase')){
        icon_filter($unibase);  
      }
      $this.toggleClass('active');
    });
  }
  */
  /* Icons Filter on Collection page */
  
  
});

$('.landing-product-right ul').slick({
  dots: true,
  infinite: true,
  speed: 500,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 5000,
  fade: true,
  cssEase: 'linear'
});

$('.landing-highest-slider-wrapper').slick({
  dots: false,
  infinite: true,
  speed: 500,
  arrows: true
});

$('.landing-logos-wrapper').slick({
  slidesToShow: 8,
  slidesToScroll: 4,
  dots: false,
  autoplay: true,
  autoplaySpeed: 4000,
  infinite: true,
  speed: 500,
  arrows: true,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


// $('.homepagetestimonials').slick({
//   arrows: true,
//   infinite: true,
//   autoplay: true,
//   autoplaySpeed: 6000,  
//   speed: 300,
//   slidesToShow: 2,
//   slidesToScroll: 2,
//   dots: true,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });

  
// Assuming each logo has a class 'landing-logo'
const logos = document.querySelectorAll('.landing-logos');

logos.forEach((logo, index) => {
  // Adjust animation duration based on index to create a continuous effect
  logo.style.animationDuration = `${10 + index * 2}s`;
});


// poster frame click event
$(document).on('click','.js-videoPoster',function(ev) {
  ev.preventDefault();
  var $poster = $(this);
  var $wrapper = $poster.closest('.js-videoWrapper');
  videoPlay($wrapper);
});

// play the targeted video (and hide the poster frame)
function videoPlay($wrapper) {
  var $iframe = $wrapper.find('.js-videoIframe');
  var src = $iframe.data('src');
  // hide poster
  $wrapper.addClass('videoWrapperActive');
  // add iframe src in, starting the video
  $iframe.attr('src',src);
}

// stop the targeted/all videos (and re-instate the poster frames)
function videoStop($wrapper) {
  // if we're stopping all videos on page
  if (!$wrapper) {
    var $wrapper = $('.js-videoWrapper');
    var $iframe = $('.js-videoIframe');
    // if we're stopping a particular video
  } else {
    var $iframe = $wrapper.find('.js-videoIframe');
  }
  // reveal poster
  $wrapper.removeClass('videoWrapperActive');
  // remove youtube link, stopping the video from playing in the background
  $iframe.attr('src','');
}

// Account page Header sticky
$(document).scroll(function () {
    var y = $(this).scrollTop();
    if (y > 200) {
        $('.sticky-header').fadeIn();
    } else {
        $('.sticky-header').fadeOut();
    }

});


$('.review_main').slick({
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
  slidesToShow: 1,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 719,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,  
        infinite: true,
      }
    },
  ],
});

$(document).ready(function() {
  var audio1 = new Audio($('#clip-a').attr('src'));
  var audio2 = new Audio($('#clip-b').attr('src'));
  var audio3 = new Audio($('#clip-c').attr('src'));
  audio1.loop = true;
  audio2.loop = true;
  audio3.loop = true;
  
  $('.audio_section .content .audio_part .left_icon').click(function() {
    if($(this).hasClass('active')) {
      audio1.pause(); 
      audio2.pause();
      audio3.pause();
      $(this).removeClass('active');
    }
    else {
      audio1.play(); 
      audio2.play();
      audio3.play();
      var val = $(".audio_section .content .audio_part input[type='range']").val();
      if(val == '0') {
        $("#clip-a").prop('muted', true);
        $("#clip-b").prop('muted', true);
        $("#clip-c").prop('muted', false);
        audio1.muted = true;
        audio2.muted = true;
        audio3.muted = false;
      }
      else if(val == '50') {
        $("#clip-a").prop('muted', true);
        $("#clip-b").prop('muted', false);
        $("#clip-c").prop('muted', true);
        audio1.muted = true;
        audio2.muted = false;
        audio3.muted = true;
      }
      else {
        $("#clip-a").prop('muted', false);
        $("#clip-b").prop('muted', true);
        $("#clip-c").prop('muted', true);
        audio1.muted = false;
        audio2.muted = true;
        audio3.muted = true;
      }
      $(this).addClass('active');
    }
    
    
  });
  $('.audio_section .content .audio_part .scroll_option ul li').click(function() {
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    var val = $(this).attr('data-val');
    $(".audio_section .content .audio_part input[type='range']").val(val);
    if(val == '0') {
      $("#clip-a").prop('muted', true);
      $("#clip-b").prop('muted', true);
      $("#clip-c").prop('muted', false);
      audio1.muted = true;
      audio2.muted = true;
      audio3.muted = false;
    }
    else if(val == '50') {
      $("#clip-a").prop('muted', true);
      $("#clip-b").prop('muted', false);
      $("#clip-c").prop('muted', true);
      audio1.muted = true;
      audio2.muted = false;
      audio3.muted = true;
    }
    else {
      $("#clip-a").prop('muted', false);
      $("#clip-b").prop('muted', true);
      $("#clip-c").prop('muted', true);
      audio1.muted = false;
      audio2.muted = true;
      audio3.muted = true;
    }
  });

  $(".audio_section .content .audio_part input[type='range']").change(function() {
    var val = $(this).val();
    if(val == '0') {
      $("#clip-a").prop('muted', true);
      $("#clip-b").prop('muted', true);
      $("#clip-c").prop('muted', false);
      audio1.muted = true;
      audio2.muted = true;
      audio3.muted = false;
    }
    else if(val == '50') {
      $("#clip-a").prop('muted', true);
      $("#clip-b").prop('muted', false);
      $("#clip-c").prop('muted', true);
      audio1.muted = true;
      audio2.muted = false;
      audio3.muted = true;
    }
    else {
      $("#clip-a").prop('muted', false);
      $("#clip-b").prop('muted', true);
      $("#clip-c").prop('muted', true);
      audio1.muted = false;
      audio2.muted = true;
      audio3.muted = true;
    }
  });

  /* login register page placeholder issue */
  /*
  var $email = $('#customer_email').val();  
  if($email != ''){
    $('#customer_email').next('.form-field-title').hide();
  }
  var $pass = $('#customer_password').val();  
  if($pass != ''){
    $('#customer_password').next('.form-field-title').hide();
  }  
  var $reg_email = $('#register_email').val();  
  if($reg_email != ''){
    $('#register_email').next('.form-field-title').hide();
  }
  var $reg_pass = $('#register_password').val();  
  if($reg_pass != ''){
    $('#register_password').next('.form-field-title').hide();
  }
  */

});

// Boost Search for mobile
//$(window).load(function() {
  $(document).ready(function(){
    if( $(window).width() < 720 ){
      //console.log('called');
      var isALARendered11;
      function ALAcheck11() {
        isALARendered11 = setInterval(function () {
          customALA11()
        }, 600);
      }
      ALAcheck11();
      function customALA11() {
        //console.log('ala-called');
        if($('.boost-pfs-search-suggestion-mobile-top-panel').length > 0) {
          clearInterval(isALARendered11);
          //console.log('clear called');
          //$(document).on('click', 'a.site-header-mobile-search-button', function(event) {
          $('a.site-header-mobile-search-button').click(function(e){
            e.preventDefault();
            $('.boost-pfs-search-suggestion-mobile-overlay').css('display','block');
            $('.boost-pfs-search-suggestion-mobile-top-panel').css('display','block');
          });
  
          $(document).on('click', function(event) {
            if (!$(event.target).closest('.boost-pfs-search-suggestion-mobile-top-panel').length && $('.boost-pfs-search-suggestion-mobile-overlay').is(':visible') && !$(event.target).closest('.site-header-mobile-search-button--button').length){
              $('.boost-pfs-search-suggestion-mobile-overlay').css('display','none');
              $('.boost-pfs-search-suggestion-mobile-top-panel').css('display','none');
            }
          });
        }
      }
    }
  });


 jQuery(document).ready(function(){
    if ($(window).width() < 767) { 
     if( $('.Compatibility-logo').length > 0 ){
       function createSlick(){
      jQuery('.Compatibility-logo').not('.slick-initialized').slick({
        rows: 2,
        dots: false,
        infinite: false,
        autoplay: true,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 2,
      });
    }
createSlick();
      // setTimeout(function(){
      //   $('.Compatibility-logo').slick('refresh'); 
      // },550);
       }
    };                    
  
    });


 jQuery(document).ready(function(){
    if ($(window).width() < 767) { 
     if( $('.support-carousel').length > 0 ){
       function createSlick(){
      jQuery('.support-carousel').not('.slick-initialized').slick({
        rows: 1,
        dots: true,
        infinite: true,
        autoplay: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    }
createSlick();
      // setTimeout(function(){
      //   $('.Compatibility-logo').slick('refresh'); 
      // },550);
       }
    };                    
  
    });




 // .our-team-carousel about us page.
   $(document).ready(function(){
  $('.our-team-carousel').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    variableWidth: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerPadding: "100px",
           responsive: [{
              breakpoint: 1199,
              settings: {
                 slidesToShow: 2,
                 slidesToScroll: 1,
                 centerPadding: "60px"
              }
           }, 
            {
              breakpoint: 768,
              settings: {
                 slidesToShow: 2,
                 slidesToScroll: 1,
                 infinite: !0,
                 centerMode: !1,
                 centerPadding: "0px"
              }
           },
            {
              breakpoint: 479,
              settings: {
                 slidesToShow: 1,
                 slidesToScroll: 1,
                 infinite: !0,
                 centerMode: !1,
                 centerPadding: "0px"
              }
           }
                        
      ]  
  });
        });

jQuery(document).ready(function(){
  function createSlick(){
  jQuery('.related-product-slider.slider').not('.slick-initialized').slick({
   dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true,
    variableWidth: false,
    slidesToShow: 4,
    slidesToScroll: 1,
           responsive: [{
              breakpoint: 992,
              settings: {
                 slidesToShow: 3,
                 slidesToScroll: 1
              }
           }, 
            {
              breakpoint: 768,
              settings: {
                 slidesToShow:2,
                 slidesToScroll:2
              }
           },
            {
              breakpoint: 541,
              settings: {
                slidesToShow:1,
                slidesToScroll:1
              }
           }                
      ]  
    });
    }
createSlick();
  });
  
  $(document).ready(function(){
    
    if( $('.price__current.free_trial').length > 0 ){
      $('.variants-ui__select-main').on('change', function(){
        var currVal = $(this).find('option:selected').data('variant-cmp-price');
        //console.log('currVal',currVal);
        var amazon_link = $(this).find('option:selected').data('amazon-link');
        console.log('amazon_link 1',amazon_link);
        // Amazon link based on variants.
        $(this).closest('.product-details').find('.product_reviews').find('.amazon_reviews_outer').find('a.amazon_reviews_badge_outer').attr('href',amazon_link);
        setTimeout(function(){
          $('.product-pricing').find('.price__current.free-message').find('.money').html(currVal);
          $('.product-main').find('.product-details__block').find('.product-title').html(title);
          //$('.product-pricing').find('.price__current.free-message').find('.money.new_price').hide();
          //$('.product-pricing').find('.price__current.free-message').find('.money.tmp_compare').hide();
          if(amazon_link != ''){
            $('form').find('.product-form--atc').find('.btn_amezon').removeClass('hide').show();
            $('form').find('.product-form--atc').find('.btn_amezon').find('a.buy-on-amazon').attr('href',amazon_link);
          }
        },70);
      });
    } else {
      $('.variants-ui__select-main').on('change', function(){
        var currVarPrice = $(this).find('option:selected').data('variant-price');
        var currCmpPrice = $(this).find('option:selected').data('variant-cmp-price');
        //console.log('currVarPrice',currVarPrice);
        //console.log('currCmpPrice',currCmpPrice);
        var amazon_link = $(this).find('option:selected').data('amazon-link');
        // Amazon link based on variants.
        $(this).closest('.product-details').find('.product_reviews').find('.amazon_reviews_outer').find('a.amazon_reviews_badge_outer').attr('href',amazon_link);
        console.log('amazon_link 2',amazon_link);
        setTimeout(function(){
          $('.product-pricing').find('.price__current').find('.prod_price').html(currVarPrice);
          $('.product-pricing').find('.price__current').find('.money.cmp_price s').html(currCmpPrice);
          if(amazon_link != ''){
            $('form').find('.product-form--atc').find('.btn_amezon').removeClass('hide').show();
            $('form').find('.product-form--atc').find('.btn_amezon').find('a.buy-on-amazon').attr('href',amazon_link);
          }
        },75);
      });
    }
    
  });

$(window).on("load", function(){
  $('.desktop-product-image').css('display', 'none');
});


